export default __webpack_public_path__ + "static/media/calibucky.0dda4a93.webp";